import createBaseService from "@/api/base-service.ts";
import type { FormTemplate } from "../../types/form-template";

const formTemplateService = {
	...createBaseService<FormTemplate>("/form-templates"),
};

export default formTemplateService;
